import React, { lazy } from "react";

const LazyContactInformation = lazy(() => import("./ContactInformation"));

const ContactInformation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyContactInformation {...props} />;

export default ContactInformation;
